module.exports = __webpack_public_path__ + "img/check-circle.fe0d3ae9.svg";